module.exports = __webpack_public_path__ + "static/img/组 7.3f156205.png";